import type { ExportLayout, ExportSegment } from '../core/export-plan';
import type { ClipScan } from '../core/scan';

export interface ScanMessage {
  readonly id: number;
  readonly file: Blob;
  readonly cacheKey: string;
  readonly telemetry: boolean;
}

export type ScanReply =
  | { readonly id: number; readonly ok: true; readonly scan: ClipScan }
  | { readonly id: number; readonly ok: false; readonly error: string };

export const scanCacheKey = (name: string, size: number, lastModified: number): string => `${name}|${size}|${lastModified}`;

export function transferablesOf(scan: ClipScan): ArrayBuffer[] {
  const arrays = [...Object.values(scan.telemetry ?? {}), ...Object.values(scan.trace ?? {})];
  return arrays.flatMap((value) => (ArrayBuffer.isView(value) && value.buffer instanceof ArrayBuffer ? [value.buffer] : []));
}

export interface NamedFile {
  readonly name: string;
  readonly file: Blob;
}

export type ExportRequest =
  | {
      readonly kind: 'render';
      readonly id: number;
      readonly segments: readonly ExportSegment[];
      readonly layout: ExportLayout;
      readonly hud: boolean;
      readonly fonts: string;
      readonly createdAt: number;
    }
  | { readonly kind: 'merge'; readonly id: number; readonly files: readonly NamedFile[] }
  | { readonly kind: 'cancel'; readonly id: number };

export type ExportReply =
  | { readonly kind: 'progress'; readonly id: number; readonly done: number; readonly total: number }
  | { readonly kind: 'done'; readonly id: number; readonly blob: Blob; readonly chapters: number; readonly seconds: number }
  | { readonly kind: 'error'; readonly id: number; readonly message: string };
